// Bus antar chart di halaman yang sama. Sengaja NOL IMPORT biar bisa diuji node.

export const HOVER = 'hover';
export const ZOOM = 'zoom';

const kanal = {};

export function subscribe(nama, fn) {
  if (!kanal[nama]) kanal[nama] = [];
  kanal[nama].push(fn);
  return function unsubscribe() {
    const daftar = kanal[nama];
    if (!daftar) return;
    const i = daftar.indexOf(fn);
    if (i !== -1) daftar.splice(i, 1);
  };
}

export function publish(nama, nilai) {
  // Disalin dulu: pelanggan boleh berhenti langganan di dalam handler.
  const daftar = (kanal[nama] || []).slice();
  daftar.forEach((fn) => {
    // Satu chart yang rusak gak boleh nahan chart lain.
    try {
      fn(nilai);
    } catch (e) {
      console.warn('[chartSync] pelanggan gagal', e);
    }
  });
}

export function clear(nama) {
  if (nama === undefined) {
    Object.keys(kanal).forEach((k) => { delete kanal[k]; });
    return;
  }
  delete kanal[nama];
}
